import React from 'react';
import ServiceCard from './ServiceCard';

const services = [
  {
    image: '/assets/icons/service-1.png',
    title: "Chauffeurs",
    description: "Connect with professional drivers for on-demand service on short-term, as-needed basis."
  },
  {
    image: '/assets/icons/service-2.png',
    title: "Messengers",
    description: "Provides businesses with access to a network of reliable drivers and couriers to support."
  },
  {
    image: '/assets/icons/service-3.png',
    title: "Service Providers",
    description: "Join our community of trusted professionals and earn on your own terms while delivering exceptional service to clients. More services will be added as community grows."
  },
  {
    image: '/assets/icons/service-4.png',
    title: "Businesses",
    description: "Helps businesses deliver services efficiently to their customers while managing everything."
  }
];

const ServicesSection = () => {
  return (
    <section id="our-services" className="bg-white pb-20 pt-20">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold mb-4">One App, Many Services</h2>
          <p className="text-gray-600">
            Flexible, on-demand solutions for transportation & delivery at your fingertips.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-6xl mx-auto">
          {services.map((service, index) => (
            <ServiceCard key={index} {...service} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;